import { Country } from "../../interfaces/dtos/common";
import { categories } from "../../variables";

export const categoryItems = [
    { key: categories.horses, value: 'Horses' },
    { key: categories.dogs, value: 'Dogs' }
]

export const getSearchCategoryShared = (searchParams: URLSearchParams, key: string) => {
    return searchParams.get(key);
}

export const getSearchProviderShared = (searchParams: URLSearchParams, key: string) => {
    return searchParams.get(key);
}

export const updateSearchParamsForCategoryShared = (searchParams: URLSearchParams, categoryCode: string, key: string) => {
    return updateSearchParams(searchParams, categoryCode, key);
}

export const updateSearchParamsForProviderShared = (searchParams: URLSearchParams, providerCode: string, key: string) => {
    return updateSearchParams(searchParams, providerCode, key);
}

const updateSearchParams = (searchParams: URLSearchParams, value: string, key: string) => {
    if (value && value !== ' ') {
        searchParams.set(key, value);
    } else {
        searchParams.delete(key);
    }
    return searchParams;
}

export const countriesFromList = (allCountries: Country[], countriesInList: string[], selectedCountry?: string) => {
    const countriesToCheck = [...countriesInList, selectedCountry ?? ''];
    const allCountryCodes = allCountries.map((ac) => ac.code);

    const definedCountries = allCountries.filter((ac) => countriesToCheck.some((c) => c === ac.code));
    const undefinedCountries = [... new Set(countriesToCheck.filter((ac) => !allCountryCodes.some((c) => c === ac)))];

    return [
        ...definedCountries,
        ...new Set(undefinedCountries.map((uc) => ({code: uc, name: uc})))
    ]
    .filter(c => c.code && c.code !== '')
    .toSorted((a,b) => a.name < b.name ? -1 : 1);
}
